import React, { useState, useEffect, useRef, useContext } from 'react';
import './SubtitlesCommentPopup.css';
import { AppContext } from '../../appContext';

interface ICommentPopupProps{
    onClose: ()=>void;
    onDone: (text: string)=>void;
    initialText:string;
    position: {top: number, left: number};
    boundingElement: HTMLElement;
}

export const CommentPopup = ({onClose, onDone, initialText, position, boundingElement}: ICommentPopupProps)=>{
    const { translate } = useContext(AppContext);
    const [text, setText] = useState('');
    const popupRef = useRef<HTMLDivElement>(null);
    const [offset, setOffset] = useState<{top: number, left: number}>({top: 0, left: 0});

    useEffect(()=>{
        setText(initialText);
    }, [initialText]);

    useEffect(()=>{
        if (!popupRef.current){
            return;
        }
        const bounding = boundingElement.getBoundingClientRect();
        //popupRef.current.parentElement.parentElement.parentElement.parentElement.getBoundingClientRect(); //window.document.documentElement.getBoundingClientRect();
        const menu = popupRef.current.getBoundingClientRect();
        let _top = 0;
        let _left = 0;
        if (bounding.right < position.left+menu.width){
            _left = -(-bounding.right + position.left + menu.width);
        }

        if (bounding.bottom < position.top+menu.height){
            _top = -(-bounding.bottom + position.top+menu.height);
        } 
        setOffset({top: _top, left: _left});
    }, [popupRef.current, position]);

    return <div ref={popupRef} className="subtitlesCommentPopup" style={{
            position:'relative',
            top: offset.top+'px',
            left: offset.left + 'px'
        }}>
        <div className="subtitlesCommentPopup_head">
            <div className="subtitlesCommentPopup_title">
                {translate('subtitles_comment_add')}
            </div>
            <div className="button subtitlesCommentPopup_close" onClick={onClose}>
                {translate('subtitles_comment_close')}
            </div>
        </div>
        <div className="subtitlesCommentPopup_main">
            <textarea className="subtitlesCommentPopup_input"
                value={text}
                onChange={(e)=>{setText(e.target.value)}}
            ></textarea>
        </div>
        <div className="subtitlesCommentPopup_buttons">
            <div className="button subtitlesCommentPopup_buttonDone" onClick={()=>onDone(text)}>
                {translate('subtitles_comment_done')}
            </div>
        </div>
    </div>
}
